import { api } from "@/lib/api";

// In-memory cache: a chat already opened (or prefetched) renders instantly, then refreshes in background.
const chats = new Map();
const lists = new Map();
const inflight = new Map();
const MAX = 80;

export const getChat = (id) => chats.get(id);
export const putChat = (id, v) => {
  chats.delete(id);
  chats.set(id, { ...chats.get(id), ...v });
  if (chats.size > MAX) chats.delete(chats.keys().next().value);
};
export const getList = (key) => lists.get(key);
export const putList = (key, items) => lists.set(key, items);

export function prefetchChat(id) {
  if (!id || chats.has(id) || inflight.has(id)) return inflight.get(id);
  const p = Promise.all([api.get(`/conversations/${id}`), api.get(`/conversations/${id}/messages`)])
    .then(([c, m]) => putChat(id, { conv: c.data.conversation, acc: c.data.account, msgs: m.data.items, hasMore: m.data.has_more }))
    .catch(() => {})
    .finally(() => inflight.delete(id));
  inflight.set(id, p);
  return p;
}

export async function prefetchMany(ids, workers = 3) {
  const q = [...ids];
  const run = async () => { while (q.length) await prefetchChat(q.shift()); };
  await Promise.all(Array.from({ length: workers }, run));
}
